module.exports = new __parcel__URL__("parasite.24e5d54d.jpg").toString();